"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "next-themes";
import { useMemo } from "react";
import { Toaster } from "@/components/ui/sonner";
import { AppConfigProvider } from "@/lib/config";
import { adminMessages } from "@/lib/i18n/messages";
import { I18nProvider } from "@llmgateway/i18n/react";
import type { Locale } from "@llmgateway/i18n";
import type { AppConfig } from "@/lib/config-server";
import type { ReactNode } from "react";
interface ProvidersProps {
  children: ReactNode;
  config: AppConfig;
  defaultLocale: Locale;
}
export function Providers(t0) {
  const $ = _c(12);
  const {
    children,
    config,
    defaultLocale
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
          staleTime: 300000,
          retry: false
        }
      }
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const queryClient = t1;
  let t2;
  if ($[1] !== children) {
    t2 = <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Toaster />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <ThemeProvider attribute="class" defaultTheme="system" enableSystem={true} storageKey="theme">{t2}{t3}</ThemeProvider>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== defaultLocale || $[7] !== t4) {
    t5 = <I18nProvider defaultLocale={defaultLocale} messages={adminMessages}>{t4}</I18nProvider>;
    $[6] = defaultLocale;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== config || $[10] !== t5) {
    t6 = <AppConfigProvider config={config}>{t5}</AppConfigProvider>;
    $[9] = config;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}